export default __webpack_public_path__ + "static/media/3.8ca90846.png";